export function unitTypeStyles(unitType, classes) {
  unitType = unitType.toLowerCase()
  const validUnitTypes = ['fire', 'ems', 'police', 'default']
  if (!validUnitTypes.includes(unitType)) {
    unitType = 'default'
  }

  return `${[unitType, ...classes].join(' ')}`
}
